import { render } from "./Sarana.vue?vue&type=template&id=df4d45d0"
import script from "./Sarana.vue?vue&type=script&lang=js"
export * from "./Sarana.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__